import { organizationDetailSchema } from '@fluxus/shared';
import { useQuery } from '@tanstack/react-query';
import { ArrowLeft } from 'lucide-react';
import { Link, useParams } from 'react-router';
import { PageContainer, PageHeader } from '@/components/layout/PageHeader';
import { CompanyNav } from '@/features/organizations/CompanyNav';
import { PermissionsPanel } from '@/features/permissions/PermissionsPanel';
import { TwoFactorPolicyPanel } from '@/features/permissions/TwoFactorPolicyPanel';
import { useAuth } from '@/lib/auth/session';

/** Perfis e permissões de uma empresa cliente (T-026d, RN-24): aba da empresa (DEC-019). */
export function PerfisPage() {
  const { organizationId = '' } = useParams();
  const { client } = useAuth();
  const org = useQuery({
    queryKey: ['organizations', 'detail', organizationId],
    queryFn: ({ signal }) =>
      client.request(`/organizations/${organizationId}`, { schema: organizationDetailSchema, signal }),
  });

  return (
    <PageContainer className="max-w-5xl">
      <Link
        to={`/empresas/${organizationId}`}
        className="inline-flex items-center gap-1.5 text-sm font-semibold text-muted-foreground hover:text-foreground"
      >
        <ArrowLeft className="size-4" aria-hidden />
        {org.data?.name ?? 'Empresa'}
      </Link>
      <PageHeader
        className="mt-4"
        title="Perfis e permissões"
        description="O que cada perfil da empresa pode ver e fazer em cada módulo, e se enxerga a empresa toda ou só as próprias áreas."
      />
      <CompanyNav organizationId={organizationId} />
      {/* key: outra empresa na mesma rota começa sem as edições da anterior. */}
      <TwoFactorPolicyPanel key={`2fa-${organizationId}`} organizationId={organizationId} />
      <PermissionsPanel key={organizationId} organizationId={organizationId} />
    </PageContainer>
  );
}
